<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="top_head">
      <div class="page-tit__wrap">
        <h1 class="page-tit__sub">취약점 제보</h1>
        <p class="page-tit">취약점 신고 관리</p>
      </div>

      <div class="write-edit">
        <div class="write-edit__wrap between">
          <ReportTimeline
            v-if="timelineData"
            :timelineTooltipData="timelineData"
          />
          <template v-if="modReportInfo.canEdit">
            <div v-if="!edit" class="write-edit-only-mobile">
              <span class="write-edit__txt">조회 모드</span>
              <button
                type="button"
                class="btn btn--green"
                @click="changeMod(true)"
              >
                편집
              </button>
            </div>
            <div v-if="edit">
              <span class="write-edit__txt"
                >편집 모드 <span class="write-edit__editable">수정 가능</span>
              </span>
              <span class="write-edit__btn-area">
                <button
                  type="button"
                  class="btn btn--green write-edit__btn"
                  @click="changeMod(false)"
                >
                  조회
                </button>
                <button
                  type="button"
                  class="btn btn--darker_blue write-edit__btn"
                  @click="isModal = true"
                >
                  저장
                </button>
              </span>
            </div>
          </template>
        </div>
      </div>
    </section>
    <!-- 탭 메뉴 -->
    <Tabs
      :tabs="['취약점 정보', '문의 접수']"
      v-model="selectedTab"
      role="tablist"
    />
    <!-- <div v-if="isLoading" class="no-data">
      데이터 조회중입니다. 잠시만 기다려주십시오.
    </div> -->

    <!-- 탭 내용 -->
    <component
      v-model="totalInfo"
      serviceType="report"
      :key="componentKey"
      :is="currentTabComponent"
      :modReportInfo="modReportInfo"
      :feedbackInfo="feedbackInfo"
      :rewardNmCodes="rewardNmCodes"
      :vulAttackTypeCodes="vulAttackTypeCodes"
      :vulEffectCodes="vulEffectCodes"
      :makrSeCdCodes="makrSeCdCodes"
      @refresh-feedback="getRecordDetail"
      :edit="edit"
      @changeTab="changeTab"
      @uploadFile="handleFileAdd"
      @download="downloadAttach"
    />
    <ModReasonModal :isModal="isModal" @close="closeModal" @set="setReport" />
  </div>
</template>

<script>
import { computed, ref, onMounted, inject, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Tabs from "@/component/Tabs.vue";
import RecordInfo from "@/views/report/submission/CommonUserTab/VulInfoTab.vue";
import Feedback from "./FeedbackTab.vue";
import ModReasonModal from "../modal/ModReasonModal.vue";
import ReportTimeline from "./ReportTimeline.vue";
import dc from "@/component/DataChk.js";
import reportHandler from "../ReportHandler.js";

export default {
  components: {
    RecordInfo,
    Feedback,
    Tabs,
    ModReasonModal,
    ReportTimeline,
  },
  setup() {
    const lodash = inject("lodash");
    const route = useRoute();
    const router = useRouter();
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const componentKey = ref(0);
    const feedbackInfo = ref(null);
    const timelineData = ref(null);
    const selectedTab = ref(0); // 탭 인덱스 관리
    const edit = ref(false);
    const isModal = ref(false);

    const rewardNmCodes = ref([]); //신고포상제 유형 코드정보
    const vulAttackTypeCodes = ref([]); //신고포상제 유형 코드정보
    const vulEffectCodes = ref([]); //신고포상제 유형 코드정보
    const makrSeCdCodes = ref([]); // 소프트웨어 유형 대분류 코드정보
    const originTotalInfo = ref(null);
    const modReportInfo = ref(reportHandler.createModReportInfo());
    const totalInfo = ref(reportHandler.getTotalInfo());

    // methods 정의
    const isReportChanged = () => {
      return (
        JSON.stringify(originReportInfo.value) !==
        JSON.stringify(totalInfo.value.reportInfo)
      );
    };
    const normalize = (val, exclude = new Set(["id"])) => {
      if (!dc.nullChk(val)) {
        return null;
      }
      if (typeof val === "object") {
        const out = {};
        Object.keys(val)
          .filter((k) => !exclude.has(k))
          .sort()
          .forEach((k) => {
            out[k] = normalize(val[k], exclude);
          });
        return out;
      }
      return val;
    };

    const isEvalChanged = () => {
      const a = normalize(originCvssEval.value);
      const b = normalize(totalInfo.value.cvssEval);
      return JSON.stringify(a) !== JSON.stringify(b);
    };

    const changeTab = async (nextIndex) => {
      selectedTab.value = nextIndex;
      await nextTick();
      window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
    };

    const getRecordDetail = () => {
      const vulId = route.query.id;

      feedbackInfo.value = null;
      originTotalInfo.value = null;

      showLoading();
      axios
        .post("/report/pr/records/detail/get", {
          vulId: vulId,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const resData = res.data.resList[0];
            modReportInfo.value.hasDistributed = resData?.hasDistributed;
            modReportInfo.value.canEdit = resData?.canEdit;
            Object.assign(totalInfo.value.reportInfo, resData?.reportInfo);
            // console.log("barklog 1: ", totalInfo.reportInfo);
            // console.log("barklog 2: ", res.data.resList[0].reportInfo);

            if (totalInfo.value.reportInfo === null) {
              alert("조회된 신고정보가 없습니다. 이전 페이지로 이동합니다.");
              router.go(-1);
            }
            getReportStatus();
            const cvssEval = dc.nullChk(resData.reportCvssEval)
              ? resData.reportCvssEval
              : reportHandler.getTotalInfo().cvssEval;

            Object.assign(totalInfo.value.cvssEval, cvssEval);

            componentKey.value++;
            feedbackInfo.value = resData.feedback;

            originTotalInfo.value = {
              reportInfo: lodash.cloneDeep(totalInfo.value.reportInfo),
              cvssEval: lodash.cloneDeep(totalInfo.value.cvssEval),
            };
          } else {
            alert("조회된 신고정보가 없습니다. 이전 페이지로 이동합니다.");
            router.go(-1);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const closeModal = () => {
      isModal.value = false;
    };
    const setReport = async (reasonInfo) => {
      modReportInfo.value.reasonCode = reasonInfo.reasonCode;
      modReportInfo.value.description = reasonInfo.description;

      showLoading();
      reportHandler
        .setReport(totalInfo.value, modReportInfo.value)
        .then((res) => {
          hideLoading();
          if (res) {
            closeModal();
            edit.value = false;
            getRecordDetail();
            changeTab(0);
          }
        });
    };
    const changeMod = (mode) => {
      let reportChange = false;
      let evalChange = false;

      if (!mode) {
        reportChange = dc.isChanged(
          originTotalInfo.value.reportInfo,
          totalInfo.value.reportInfo
        );
        evalChange = dc.isChanged(
          originTotalInfo.value.cvssEval,
          totalInfo.value.cvssEval
        );
      }

      if (reportChange || evalChange) {
        if (confirm("변경 사항이 있습니다. 저장 하시겠습니까?")) {
          isModal.value = true;
          return;
        } else {
          totalInfo.value.reportInfo = lodash.cloneDeep(
            originTotalInfo.value.reportInfo
          );

          totalInfo.value.cvssEval = lodash.cloneDeep(
            originTotalInfo.value.cvssEval
          );

          reportChange = false;
          evalChange = false;
          componentKey.value++;
        }
      }

      edit.value = mode;
    };

    const getReportStatus = () => {
      const data = {
        vulId: route.query.id,
      };
      axios
        .post("/report/pr/records/status/get", data)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            timelineData.value = res.data.resList;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // 신고포상제 세팅
    const getRewardNm = async () => {
      const result = await reportHandler.getRewardNm();
      if (Array.isArray(result)) {
        rewardNmCodes.value = result;
      }
    };
    // 공격 유형 코드 세팅
    const getVulAttackType = async () => {
      const result = await reportHandler.getVulAttackType();
      if (Array.isArray(result)) {
        vulAttackTypeCodes.value = result;
      }
    };
    // 영향 코드 세팅
    const getVulEffect = async () => {
      const result = await reportHandler.getVulEffect();
      if (Array.isArray(result)) {
        vulEffectCodes.value = result;
      }
    };

    // 소프트웨어 유형 대분류 세팅
    const getSeCode = async () => {
      const result = await reportHandler.getMakrSeCd();
      if (Array.isArray(result)) {
        makrSeCdCodes.value = result;
      }
    };
    const handleFileAdd = (file) => {
      modReportInfo.value.uploadFile = file;
    };

    const downloadAttach = (vulId, fileName) => {
      showLoading();
      axios
        .post(
          "/report/pr/file/attach/download",
          { vulId },
          { responseType: "blob" }
        )
        .then((res) => {
          const blob = new Blob([res.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName || "download";
          link.click();
          window.URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const initCodeInfo = () => {
      getRewardNm();
      getSeCode();
      getVulAttackType();
      getVulEffect();
    };

    // computed 정의
    // 현재 선택된 탭 컴포넌트 반환
    const currentTabComponent = computed(
      () => tabComponents.value[selectedTab.value]
    );
    const tabComponents = computed(() => [RecordInfo, Feedback]);
    const isLoading = computed(() => store.state.loading.isLoading);

    // life cycle 정의
    onMounted(() => {
      initCodeInfo();
      // detail api 호출
      getRecordDetail();
    });

    // html에서 사용될 데이터 정의
    return {
      totalInfo,
      selectedTab,
      changeTab,
      currentTabComponent,
      edit,
      isModal,
      closeModal,
      setReport,
      modReportInfo,
      changeMod,
      feedbackInfo,
      getRecordDetail,
      timelineData,
      getReportStatus,
      rewardNmCodes,
      vulAttackTypeCodes,
      vulEffectCodes,
      makrSeCdCodes,
      isLoading,
      componentKey,
      downloadAttach,
      handleFileAdd,
    };
  },
};
</script>

<style>
</style>